import { Alert } from "@mui/material";
import i18n from "i18next";
import { VerticalBox } from "src/components/common/box/VerticalBox";
import { ObjectAttributesForm } from "src/components/views/erp/objectAttributes/ObjectAttributesForm.tsx";
import { CatalogPartAttributesApi } from "src/api/generated/erp/parts/catalogPart/api/catalogPartAttributesApi.ts";
import { SitePartAttributesApi } from "src/api/generated/erp/parts/sitePart/api/sitePartAttributesApi.ts";
import { FormCommonProps } from "src/components/common/forms/types.ts";

export interface CatalogPartAttributesFormProps extends Partial<FormCommonProps<void>> {
	catalogPartId: number;
	/**
	 * The site part whose catalog part attributes are edited. When given, saving requires only site part management
	 * instead of catalog part management.
	 */
	sitePartId?: number;
	showSharedPartDataWarning?: boolean;
}

export const CatalogPartAttributesForm = ({
	catalogPartId,
	sitePartId,
	showSharedPartDataWarning,
	onCompleted,
	onFormEdited,
}: CatalogPartAttributesFormProps) => {
	return (
		<VerticalBox sx={{ flex: 1, gap: 2 }}>
			{showSharedPartDataWarning && (
				<Alert severity={"warning"}>{i18n.t("catalog_part_attributes_shared_part_data_warning")}</Alert>
			)}
			<ObjectAttributesForm
				fetchAttrs={() =>
					CatalogPartAttributesApi.getCatalogPartAttributes({
						catalogPartId: catalogPartId,
					})
				}
				saveAttrs={(attrs) =>
					sitePartId == null ?
						CatalogPartAttributesApi.saveCatalogPartAttributes({
							catalogPartId,
							attributes: attrs,
						})
					:	SitePartAttributesApi.saveCatalogPartAttributesOfSitePart({
							partId: sitePartId,
							attributes: attrs,
						})
				}
				onCompleted={onCompleted}
				onFormEdited={onFormEdited}
			/>
		</VerticalBox>
	);
};
